import { Tab, Tabs } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

const tabStyle = {
  color: "var(--Brand-700, #076D0D)",
  fontFamily: "Montserrat",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "20px",
  padding: "0px 4px 12px 4px",
  textTransform: "none",
  minHeight: "fit-content",
  minWidth: "fit-content",
};

const TABS = ["followers", "following"] as const;
type TabType = (typeof TABS)[number];

const NetworkTabs = ({ isDataLoading }: { isDataLoading: boolean }) => {
  const { t } = useTranslation("profiles", {
    keyPrefix: "network",
  });

  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const currentType = searchParams.get("network") || "followers";

  const handleTabChange = (event: React.SyntheticEvent, type: TabType) => {
    const searchParams = new URLSearchParams(location.search);
    Array.from(searchParams.keys()).forEach((key) => {
      searchParams.delete(key);
    });

    searchParams.set("tab", "network");
    searchParams.set("network", type);
    navigate({ search: searchParams.toString() });
  };

  return (
    <Tabs
      value={currentType}
      onChange={handleTabChange}
      aria-label="profile tabs"
      sx={{
        minHeight: "fit-content",
        "& .MuiTabs-flexContainer": {
          gap: "24px",
        },
      }}
    >
      <Tab label={t("followers")} value="followers" sx={tabStyle} disabled={isDataLoading} />
      <Tab label={t("following")} value="following" sx={tabStyle} disabled={isDataLoading} />
    </Tabs>
  );
};

export default NetworkTabs;
